var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper" },
    [
      _c("div", { staticClass: "table-caption" }, [
        _vm._v(_vm._s(_vm.$t("tenancy.table.emergencyContacts")) + " "),
        _c("small", [
          _vm._v("(" + _vm._s(_vm.$t("hint.provideLocalPhone")) + ")"),
        ]),
      ]),
      _vm._v(" "),
      _vm.allowLinkContacts
        ? _c("div", { staticClass: "link__contact" }, [
            _c(
              "button",
              {
                staticClass: "btn link__contact--btn",
                attrs: { type: "button", disabled: !_vm.tenancyId },
                on: {
                  click: function ($event) {
                    return _vm.linkFunc({ isEmergency: true })
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("tenancy.table.linkContact")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link__contact--plus" }, [_vm._v("+")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.itemHeaders, function (header, index) {
                return _c("th", { key: index, class: header.class }, [
                  _vm._v(_vm._s(header.name)),
                ])
              }),
              _vm._v(" "),
              _c("th", { staticClass: "column-header-remarks" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.table.remarks"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "column-header-remarks" }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.emergencyContacts, function (item, key) {
            return _c("tr", { key: _vm.getKey(key) }, [
              _c("td", { staticClass: "number-column" }, [
                _vm.canAccessContact
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "name-hyper-link",
                          on: {
                            click: function ($event) {
                              return _vm.navToContactDetail(item.id, true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.displayI18nFullName(
                                item.firstName,
                                item.lastName
                              ) || item.name
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isEngineer
                        ? _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!item.remarks,
                                expression: "!!item.remarks",
                              },
                            ],
                            staticClass: "remark-included-flag",
                          })
                        : _vm._e(),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.displayI18nFullName(
                              item.firstName,
                              item.lastName
                            ) || item.name
                          ) +
                          "\n          "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.getAllPhones(item)))]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "check-column",
                  class: {
                    "error-highlight-background":
                      _vm.isItemRequireHighlight(item),
                  },
                },
                [
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      id: "checkbox_" + key,
                      type: "checkbox",
                      disabled: !_vm.allowLinkContacts,
                    },
                    domProps: {
                      checked: item.workingHourOrder ? "checked" : "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updatePositionCheckBox(
                          item.index,
                          key,
                          !item.workingHourOrder,
                          true
                        )
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("HKLSelect", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      disabled:
                        !_vm.allowLinkContacts || !item.workingHourOrder,
                      value: item.workingHourOrder || undefined,
                      options: _vm.workingHourPositionHklOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        return _vm.updatePosition(key, "workingHourOrder", val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "check-column",
                  class: {
                    "error-highlight-background":
                      _vm.isItemRequireHighlight(item),
                  },
                },
                [
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      id: "checkbox_" + key,
                      type: "checkbox",
                      disabled: !_vm.allowLinkContacts,
                    },
                    domProps: {
                      checked: item.nonWorkingHourOrder ? "checked" : "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updatePositionCheckBox(
                          item.index,
                          key,
                          !item.nonWorkingHourOrder,
                          false
                        )
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("HKLSelect", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      disabled:
                        !_vm.allowLinkContacts || !item.nonWorkingHourOrder,
                      value: item.nonWorkingHourOrder || undefined,
                      options: _vm.nonWorkingHourPositionHklOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        return _vm.updatePosition(
                          key,
                          "nonWorkingHourOrder",
                          val
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("TextField", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      parentNode: "",
                      value: item.oRemarks,
                      disabled: !_vm.allowLinkContacts,
                      readonly: !_vm.allowLinkContacts,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateRemarks(item.index, val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "icon-remove" }, [
                _vm.allowLinkContacts
                  ? _c("i", {
                      staticClass: "fa fa-times-thin",
                      on: {
                        click: function ($event) {
                          return _vm.openDeleteConfirm(item.index, key)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }